import React from "react";
import R from "ramda";
import { InlineTabs } from "components/common/inline-tabs";

export const DocumentsInlineTabs = (props) => (
  <div>
    <InlineTabs tabValues={ tabValues(props) } />
  </div>
);

const hardCodedTabs = (accountSlug, currentPage) => (
  [
    {
      name: "All Documents",
      path: `/accounts/${accountSlug}/documents/all`,
      isSelected: currentPage === "all" || currentPage === "all/:filter"
    },
    {
      name: "This Financial Year",
      path: `/accounts/${accountSlug}/documents/this-financial-year`,
      isSelected: currentPage === "this-financial-year"
    }

  ]
);

const tabValues = ({
  accountSlug,
  currentPage,
  customTabs,
  onStartDeleteCustomTabMode,
  routeParams
}) => {
  const initialTabs = hardCodedTabs(accountSlug, currentPage);
  if (!customTabs) {
    return R.append(addTabObject(accountSlug, currentPage), initialTabs);
  }
  const selected = currentPage === "custom/:customTab" ? routeParams.customTab : currentPage;
  const customTabArray = customTabs.map((tab) => ({
    id: tab.id,
    name: tab.name,
    path: `/accounts/${accountSlug}/documents/custom/${tab.id}`,
    isCustom: true,
    isSelected: selected === tab.id,
    onDelete: () => onStartDeleteCustomTabMode(tab.id)
  }));

  if (customTabs.length > 2) {
    return R.concat(initialTabs, customTabArray);
  }
  const newCustomTabArray = R.append(addTabObject(accountSlug, currentPage), customTabArray);
  return R.concat(initialTabs, newCustomTabArray);
};

const addTabObject = (accountSlug, currentPage) => ({
  name: "+",
  path: `/accounts/${accountSlug}/documents/custom-tab`,
  isSelected: currentPage === "custom-tab"
});



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-inline-tabs.jsx